"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollateralCreditSource = void 0;
/**
 * Origin of an ad-hoc collateral credit. Each variant maps to a real business reason for depositing
 * collateral outside the normal deposit flow; the variant becomes the ledger external_source. Add a
 * new variant per new credit type (e.g. a future CryptoCashbackRedemption).
 * @TranslateToRust
 */
var CollateralCreditSource;
(function (CollateralCreditSource) {
    CollateralCreditSource["CryptoReferralReward"] = "CryptoReferralReward";
})(CollateralCreditSource || (exports.CollateralCreditSource = CollateralCreditSource = {}));
